import { LoaderWrapper, Spinner } from '@/styles/common';
import React from 'react';

interface LoaderProps {
	opacity?: string;
}

export const Loader: React.FC<LoaderProps> = ({ opacity }) => {
	return (
		<LoaderWrapper opacity={opacity}>
			<Spinner />
		</LoaderWrapper>
	);
};
